exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".verticalList>.editorGroup{padding-top:5px;flex-shrink:0}.verticalList>.editorGroup:last-child{padding-bottom:5px}.horizontalList>.editorGroup:not(:last-child){padding-right:5px}.horizontalList>.editorGroup{padding-top:3px;padding-bottom:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/FormItemGroupStyle.css
// module id = 302
// module chunks = 1 2 3 4 5 7